const updates = [
  {
    title: '《流浪地球3》4K超清版本现已上线',
    time: '2小时前',
    tag: '新片上线',
    tagColor: 'bg-accent-500',
  },
  {
    title: '平台服务器全面升级，加载速度提升40%',
    time: '6小时前',
    tag: '系统升级',
    tagColor: 'bg-primary-500',
  },
  {
    title: '暑期档专题「炎夏光影季」正式上线',
    time: '昨天',
    tag: '专题活动',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '新增200+经典港片4K修复版本',
    time: '昨天',
    tag: '片库更新',
    tagColor: 'bg-primary-500',
  },
  {
    title: '移动端体验优化，新增省流模式',
    time: '2天前',
    tag: '功能更新',
    tagColor: 'bg-secondary-500',
  },
  {
    title: '《奥本海默》导演剪辑版独家上线',
    time: '3天前',
    tag: '新片上线',
    tagColor: 'bg-accent-500',
  },
  {
    title: '用户反馈通道升级，意见处理更快',
    time: '4天前',
    tag: '服务优化',
    tagColor: 'bg-background-500',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">最新动态</h2>
          <p className="text-foreground-500 text-sm mt-2">平台更新与内容快讯</p>
        </div>
        <div className="relative pl-6 border-l-2 border-background-200/60 space-y-5 md:space-y-6">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[25px] top-1 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></div>
              <div className="flex flex-wrap items-start gap-2 md:gap-3">
                <span className={`px-2.5 py-1 rounded-full text-xs font-medium text-background-950 ${item.tagColor} whitespace-nowrap`}>
                  {item.tag}
                </span>
                <span className="text-foreground-600 text-xs whitespace-nowrap">{item.time}</span>
              </div>
              <h3 className="mt-2 font-heading text-sm md:text-base font-semibold text-foreground-200">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}